exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-practitioner-components-nav-profile-nav-profile-switch-user-styles__activeUser {\n  cursor: default;\n  pointer-events: none;\n}\n", ""]);

// exports
exports.locals = {
	"activeUser": "src-practitioner-components-nav-profile-nav-profile-switch-user-styles__activeUser"
};